import { useState, useEffect, useRef } from "react";
import CommonObj from "../../CommonObj";
import { generatePresignedUrl } from "./AWSS3Bucket";
import WilliamsLeeLogo from "../../assets/svg/hcmloginwilliamslealogo.svg";
import QRCode from '../../assets/img/GooglePlayStoreQRCode.png';
import IOSQRCode from '../../assets/img/AppStoreQRCode.png';
import configJson from   '../../Config.json';

import Preloader from './Preloader'
import "./About.css"
import { useAuth } from "react-oidc-context";
import DefaultLogin from "./DefaultLogin";

const SLIDE_MIN = 1;
const SLIDE_MAX = 3;
const AUTO_SLIDE_DELAY = 2000;

const LoginPage = (pageId) => {
  const auth = useAuth();
  const [page, setPageData] = useState();
  const [activeIndex, setActiveIndex] = useState(SLIDE_MIN);
  const timerRef = useRef();

  useEffect(() => {
    timerRef.current = setTimeout(() => {
      setActiveIndex((prev) => prev === SLIDE_MAX ? SLIDE_MIN : (prev + 1) );
    }, AUTO_SLIDE_DELAY);

    return () => clearTimeout(timerRef.current);
  }, [activeIndex]);

  const handleClick = (idx) => {
    clearTimeout(timerRef.current);
    setActiveIndex(idx);
  };

  
  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const res = await fetch(CommonObj.Endpoints.GetCommonDetails, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        const data = await res.json();        
        if (isMounted) {
          setPageData(data);
        }
      } catch (error) {
        if (isMounted) {
          console.error("Failed to fetch login data:", error);
        }
      }
    };
    fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  if(!page)
  {
    return (<DefaultLogin></DefaultLogin>)
  }

  if (page != null && page != undefined) {
    const items = page.filter((x) => x.is_Menu == "True");
    const panelheader = page.filter(
      (x) => x.config_ID == "9" || x.config_ID == "10" || x.config_ID == "11"
    );
    const support = page.filter((x) => x.config_ID == "1");
    const Internaltionsupport = page.filter((x) => x.config_ID == "20");
    const email = page.filter((x) => x.config_ID == "2");
    const copyright = page.filter((x) => x.config_ID == "3");
    const query = page.filter((x) => x.config_ID == "12");
    const chatbot = page.filter((x) => x.config_ID == "13");
    const helptext = page.filter((x) => x.config_ID == "14");
    return (
      <div className={`login-page-body-container coursel-${activeIndex}`}>
        <div className="login-page-left-container">
          <div className="login-page-left-backgound-1">
            <div className="login-page-left-backgound-2">
              <div className="login-page-left-backgound-3">
                <div className="login-page-left-rrdlogo-container">
                  <svg
                    width="50"
                    height="50"
                    viewBox="0 0 50 50"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.4326 1.90332C20.0007 0.011165 25.0275 -0.48409 29.877 0.480469C34.7265 1.4451 39.1814 3.82595 42.6777 7.32227C46.174 10.8186 48.5549 15.2735 49.5195 20.123C50.4841 24.9725 49.9888 29.9993 48.0967 34.5674C46.2045 39.1353 43.0007 43.0402 38.8896 45.7871C34.7784 48.5341 29.9445 50 25 50C18.3696 50 12.0107 47.3661 7.32227 42.6777C2.63386 37.9893 0 31.6304 0 25C4.14775e-06 20.0555 1.46586 15.2216 4.21289 11.1104C6.95985 6.99928 10.8647 3.79551 15.4326 1.90332Z"
                      fill="#002449"
                    />
                    <path
                      d="M41.7561 14.4351H38.5186C38.4935 14.4351 38.4695 14.445 38.4517 14.4626C38.4339 14.4802 38.4237 14.5041 38.4235 14.5292V27.1111C38.4141 28.4646 37.8675 29.7591 36.9038 30.7096C35.9402 31.6602 34.6384 32.189 33.2848 32.1799C32.8781 32.1883 32.4715 32.1571 32.0708 32.0868L32.0465 32.0808C31.9878 32.0696 31.9301 32.0555 31.8725 32.0413H31.8613C31.7986 32.0251 31.7359 32.0089 31.6742 31.9877C31.3409 31.893 31.0187 31.7631 30.713 31.6002L30.6776 31.585C30.4026 31.4491 30.1402 31.2889 29.8935 31.1064C29.6822 30.9518 29.4817 30.7828 29.2936 30.6006C29.2793 30.5869 29.2618 30.5771 29.2426 30.5723C29.2235 30.5675 29.2034 30.5677 29.1844 30.573C29.1654 30.5783 29.1481 30.5885 29.1342 30.6026C29.1204 30.6167 29.1104 30.6341 29.1054 30.6532L28.2646 33.8746C28.2541 33.9153 28.2558 33.9582 28.2695 33.9979C28.2831 34.0377 28.3082 34.0725 28.3415 34.0981C28.5204 34.2439 28.7144 34.3701 28.9202 34.4745C30.2206 35.1941 31.6833 35.5695 33.1695 35.5652H33.2879C35.1383 35.5675 36.9401 34.9736 38.4265 33.8715V35.465C38.4265 35.4775 38.4289 35.4898 38.4337 35.5013C38.4385 35.5127 38.4456 35.5231 38.4544 35.5319C38.4632 35.5406 38.4737 35.5476 38.4853 35.5522C38.4968 35.5569 38.5092 35.5592 38.5216 35.5591H41.7591C41.7721 35.5599 41.785 35.5581 41.7972 35.5537C41.8094 35.5494 41.8205 35.5426 41.83 35.5338C41.8395 35.525 41.847 35.5144 41.8522 35.5026C41.8575 35.4907 41.8602 35.4779 41.8603 35.465V14.5292C41.8585 14.5036 41.8471 14.4796 41.8283 14.4621C41.8095 14.4447 41.7848 14.435 41.7591 14.4351"
                      fill="white"
                    />
                    <path
                      d="M8.24167 35.5665H11.4792C11.5043 35.5665 11.5283 35.5566 11.5461 35.539C11.5639 35.5214 11.574 35.4974 11.5743 35.4724V27.1114C11.5837 25.758 12.1302 24.4638 13.0936 23.5132C14.057 22.5627 15.3585 22.0337 16.7119 22.0426C17.1187 22.0345 17.5253 22.066 17.926 22.1367H17.9503C18.009 22.1499 18.0676 22.162 18.1243 22.1772H18.1354C18.1992 22.1934 18.2619 22.2106 18.3236 22.2298C18.6569 22.3263 18.9793 22.4568 19.2858 22.6193L19.3202 22.6355C19.5955 22.7711 19.8583 22.9309 20.1053 23.113C20.3162 23.2682 20.5166 23.4372 20.7052 23.6189C20.7196 23.6323 20.7373 23.6418 20.7564 23.6464C20.7755 23.651 20.7955 23.6506 20.8144 23.6452C20.8334 23.6398 20.8506 23.6296 20.8644 23.6156C20.8783 23.6016 20.8882 23.5843 20.8934 23.5653L21.7342 20.3449C21.7448 20.3041 21.7431 20.261 21.7294 20.2211C21.7158 20.1812 21.6907 20.1461 21.6573 20.1203C21.4778 19.9753 21.2839 19.8492 21.0786 19.744C19.7778 19.0254 18.3153 18.6504 16.8293 18.6543C16.7888 18.6543 16.7493 18.6543 16.7099 18.6543C14.86 18.6517 13.0584 19.2453 11.5723 20.347V18.7514C11.5722 18.7391 11.5696 18.7269 11.5647 18.7155C11.5599 18.7042 11.5529 18.6938 11.544 18.6852C11.5352 18.6766 11.5247 18.6697 11.5133 18.6651C11.5018 18.6605 11.4896 18.6582 11.4772 18.6584H8.23964C8.22729 18.6582 8.21502 18.6605 8.20355 18.6651C8.19208 18.6697 8.18164 18.6766 8.17281 18.6852C8.16398 18.6938 8.15693 18.7042 8.15208 18.7155C8.14723 18.7269 8.14466 18.7391 8.14453 18.7514V35.4673C8.1448 35.4924 8.15495 35.5163 8.17275 35.5339C8.19056 35.5515 8.2146 35.5614 8.23964 35.5614"
                      fill="white"
                    />
                    <path
                      d="M23.5395 35.5665H26.777C26.8027 35.5666 26.8274 35.5569 26.8462 35.5394C26.865 35.5219 26.8764 35.498 26.8782 35.4724V27.1114C26.8827 26.4412 27.0192 25.7785 27.2798 25.1611C27.5404 24.5437 27.9201 23.9836 28.3972 23.513C28.8743 23.0423 29.4394 22.6702 30.0603 22.4179C30.6811 22.1656 31.3456 22.0381 32.0158 22.0426C32.4226 22.0345 32.8292 22.066 33.2299 22.1367H33.2542C33.3128 22.1499 33.3705 22.162 33.4282 22.1772H33.4393C33.5031 22.1934 33.5648 22.2106 33.6275 22.2298C33.9605 22.3261 34.2826 22.4566 34.5886 22.6193L34.624 22.6355C34.8991 22.7709 35.1616 22.9308 35.4081 23.113C35.6195 23.2677 35.8199 23.4367 36.0081 23.6189C36.0224 23.6326 36.04 23.6423 36.0592 23.6471C36.0784 23.6519 36.0985 23.6515 36.1176 23.6461C36.1366 23.6407 36.1539 23.6304 36.1677 23.6162C36.1815 23.602 36.1914 23.5845 36.1963 23.5653L37.037 20.3449C37.0476 20.3041 37.046 20.261 37.0323 20.2211C37.0186 20.1812 36.9936 20.1461 36.9601 20.1203C36.7812 19.9751 36.5876 19.849 36.3824 19.744C35.0816 19.0256 33.6192 18.6506 32.1332 18.6543C32.0937 18.6543 32.0542 18.6543 32.0148 18.6543C30.1648 18.6516 28.3632 19.2452 26.8772 20.347V18.7514C26.8769 18.7386 26.8741 18.7259 26.8688 18.7142C26.8635 18.7025 26.856 18.692 26.8465 18.6833C26.837 18.6746 26.8259 18.6679 26.8138 18.6636C26.8017 18.6593 26.7888 18.6575 26.776 18.6584H23.5385C23.5261 18.6582 23.5138 18.6605 23.5024 18.6651C23.4909 18.6697 23.4805 18.6766 23.4716 18.6852C23.4628 18.6938 23.4558 18.7042 23.4509 18.7155C23.4461 18.7269 23.4435 18.7391 23.4434 18.7514V35.4673C23.4436 35.4924 23.4538 35.5163 23.4716 35.5339C23.4894 35.5515 23.5134 35.5614 23.5385 35.5614"
                      fill="white"
                    />
                  </svg>
                </div>
                <div className="login-page-left-content-container">
                  {panelheader &&
                    panelheader.map((data) => <h2>{data.config_Name}</h2>)}
                  {panelheader &&
                    panelheader.map((data) => <p> {data.description}</p>)}
                </div>
                <div className="login-page-carosuel-container">
                  {[1, 2, 3].map(idx =>(
                  <button key={idx} onClick={()=>handleClick(idx)} type="button"></button>)
                  )}
                </div>
              </div>
              <div className="login-page-left-footer">
                <ul className="challenge-listitem">
                  {items &&
                    items.map((data) => (
                      <li>
                        <a href={data.menu_URL}>{data.config_Name}</a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="login-page-right-container">
          <div className="login-page-right-logo-container">
            <svg width="203" height="18" viewBox="0 0 203 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M177.443 16.7773C176.275 16.8053 175.113 16.6058 174.024 16.1903C172.934 15.7748 171.939 15.1515 171.095 14.3561C170.289 13.6289 169.662 12.7308 169.26 11.7297C168.848 10.651 168.646 9.50549 168.663 8.35302C168.613 6.88307 169.006 5.43142 169.792 4.18089C170.547 2.89102 171.665 1.84415 173.011 1.16685C174.39 0.400738 175.946 -0.00121477 177.53 2.75773e-06C178.877 0.0278068 180.206 0.310587 181.444 0.832928C182.713 1.3893 183.841 2.21629 184.745 3.25417L182.485 5.25269C181.857 4.53772 181.084 3.96039 180.216 3.55799C179.347 3.15559 178.403 2.93705 177.443 2.91649C175.951 2.90814 174.515 3.47766 173.445 4.5023C172.912 4.99257 172.49 5.58756 172.206 6.24875C171.922 6.90993 171.781 7.62257 171.794 8.34052C171.788 9.32838 172.027 10.3028 172.489 11.1795C172.981 12.0041 173.705 12.6712 174.573 13.1004C175.47 13.6103 176.492 13.8697 177.528 13.8508C178.395 13.8544 179.253 13.6842 180.05 13.3506C180.969 12.8927 181.795 12.2716 182.485 11.5184L184.66 13.6895C183.655 14.6911 182.478 15.5107 181.184 16.1107C179.991 16.5621 178.722 16.7882 177.443 16.7773ZM127.723 16.3609H124.507V0.416466H127.554L134.682 10.9331V0.416466H137.811V16.3596H134.763L127.723 5.92303V16.3609ZM102.688 16.3609H99.5581V0.416466H102.514L109.642 10.9331V0.416466H112.772V16.3596H109.815L102.688 5.92303V16.3609ZM199.957 16.3609H196.74V3.42175H193.786V0.416466H203V3.418H199.953V16.3596L199.957 16.3609ZM158.582 16.3609H149.541V0.416466H158.582V3.418H152.671V6.25695H158.582V9.1822H152.671V13.3556H158.582V16.3571V16.3609Z" fill="#002449"/>
<mask id="mask0_6680_69378" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="1" width="17" height="17">
<path d="M0 1.08423H16.5659V17.0924H0V1.08423Z" fill="white"/>
</mask>
<g mask="url(#mask0_6680_69378)">
<path d="M13.5097 1.08423V1.14176H13.4983L8.28358 11.7022L3.06889 1.13801H3.05619V1.08423H0V17.0924H3.05619V7.92898L6.61137 15.0926L7.48366 16.8435L8.28358 16.8548L9.08477 16.8435L9.95706 15.0926L13.5122 7.92898V17.0924H16.5684V1.08423H13.5097Z" fill="#002449"/>
</g>
<mask id="mask1_6680_69378" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="69" y="0" width="21" height="18">
<path d="M69.437 0.576477H89.4197V17.9991H69.437V0.576477Z" fill="white"/>
</mask>
<g mask="url(#mask1_6680_69378)">
<path d="M70.3741 7.37495C71.3334 8.36011 72.3424 9.29718 73.3972 10.1826C73.9673 10.6329 74.54 11.1444 75.0834 11.6384C76.7658 13.1542 78.4951 14.7087 80.3565 14.7087C81.8327 14.7247 83.2552 14.1638 84.3124 13.1488C85.3695 12.1338 85.9751 10.7474 85.9966 9.29343C85.987 8.347 85.7271 7.41938 85.2423 6.60217C84.7576 5.78496 84.0648 5.10642 83.2324 4.63355C80.2778 2.94519 75.5672 5.09379 74.4828 8.50303L71.626 6.04427C74.9666 0.979183 78.9344 0.576477 80.0848 0.576477C80.2321 0.576477 80.3311 0.58273 80.3743 0.586482C82.7444 0.565095 85.0266 1.46913 86.7217 3.10083C88.4168 4.73253 89.3869 6.95908 89.4197 9.29343C89.3862 11.6305 88.4135 13.8592 86.7146 15.4911C85.0157 17.1229 82.7293 18.0249 80.3565 17.9991C78.7718 17.9714 77.2306 17.4832 75.9265 16.5959L69.437 6.4895" fill="#002449"/>
</g>
<path d="M67.002 13.6568L67.2001 13.3291L64.2391 11.6808L64.041 12.0085" fill="#002449"/>
<path d="M34.2015 7.78796L30.0978 1.08453H26.2671L32.5699 11.1109V17.2653H35.8712V11.1109L42.0813 1.08453H38.2138L34.2015 7.78796Z" fill="#002449"/>
<path d="M80.3547 17.9994C77.1411 17.9994 74.8086 15.8996 72.7517 14.0474C72.2172 13.5647 71.7105 13.1069 71.2192 12.718C70.0655 11.7596 68.9635 10.7422 67.9179 9.67018C65.1639 6.95129 62.0481 3.87472 59.1569 3.87472C57.6813 3.86035 56.2599 4.42232 55.2038 5.43767C54.1478 6.45301 53.543 7.83905 53.522 9.29249C53.5427 10.7466 54.1476 12.1333 55.2043 13.149C56.2609 14.1647 57.6831 14.7265 59.1595 14.7115C60.1409 14.7138 61.1062 14.4661 61.9617 13.9923C62.8171 13.5185 63.5336 12.8348 64.0415 12.0076L64.2396 11.68L67.2005 13.3283L67.0025 13.656C66.1864 14.9846 65.0353 16.0828 63.661 16.8439C62.2868 17.605 60.736 18.003 59.1595 17.9994C56.786 18.0258 54.4988 17.1241 52.7993 15.4918C51.0998 13.8596 50.1269 11.6302 50.0938 9.29249C50.1272 6.95518 51.1002 4.72629 52.7993 3.09439C54.4984 1.46249 56.7852 0.560738 59.1582 0.586792C63.1032 0.586792 66.4806 3.56832 69.4835 6.50106C69.7831 6.79371 74.8416 14.704 78.9403 17.2716L80.3547 17.9994Z" fill="#009DDB"/>
</svg>

          </div>
          <div className="login-page-right-button-container">
            <button type="button" className="login-page-right-button rrdbutton" onClick={()=> auth.signinRedirect()} >
              <span className="login-page-right-button-icon">
                <svg
                  width="30"
                  height="30"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.0006 30.0011C17.9674 30.0011 20.8676 29.1214 23.3344 27.4731C25.8013 25.8248 27.7239 23.482 28.8593 20.741C29.9946 18 30.2917 14.9839 29.7129 12.0741C29.1341 9.1643 27.7054 6.49144 25.6076 4.39357C23.5097 2.29571 20.8369 0.867036 17.927 0.288236C15.0172 -0.290564 12.0011 0.00650738 9.2601 1.14186C6.5191 2.27722 4.17633 4.19988 2.52805 6.66671C0.879766 9.13354 0 12.0338 0 15.0006C0 18.979 1.58042 22.7944 4.39357 25.6076C7.20672 28.4207 11.0222 30.0011 15.0006 30.0011Z"
                    fill="#1F2A44"
                  />

                  <path
                    d="M25.0544 8.66162H23.1118C23.0967 8.66162 23.0823 8.66756 23.0716 8.67813C23.0609 8.6887 23.0549 8.70306 23.0547 8.71809V16.2675C23.0491 17.0797 22.7211 17.8564 22.1429 18.4267C21.5647 18.9971 20.7836 19.3144 19.9714 19.3089C19.7273 19.314 19.4834 19.2953 19.2429 19.2531L19.2284 19.2494C19.1932 19.2428 19.1586 19.2343 19.124 19.2258H19.1173C19.0796 19.2161 19.042 19.2063 19.005 19.1936C18.805 19.1368 18.6117 19.0588 18.4283 18.9611L18.407 18.952C18.242 18.8704 18.0845 18.7743 17.9365 18.6648C17.8097 18.572 17.6894 18.4706 17.5765 18.3613C17.568 18.3531 17.5575 18.3472 17.546 18.3443C17.5345 18.3414 17.5225 18.3416 17.5111 18.3448C17.4996 18.348 17.4893 18.3541 17.481 18.3625C17.4726 18.371 17.4667 18.3814 17.4636 18.3929L16.9592 20.3258C16.9529 20.3502 16.9539 20.3759 16.9621 20.3998C16.9703 20.4236 16.9853 20.4445 17.0053 20.4599C17.1126 20.5474 17.229 20.6231 17.3525 20.6858C18.1328 21.1175 19.0104 21.3428 19.9022 21.3402H19.9732C21.0835 21.3416 22.1647 20.9852 23.0565 20.3239V21.2801C23.0565 21.2875 23.058 21.2949 23.0609 21.3018C23.0637 21.3087 23.068 21.3149 23.0733 21.3202C23.0786 21.3255 23.0849 21.3296 23.0918 21.3324C23.0987 21.3352 23.1061 21.3366 23.1136 21.3365H25.0562C25.0639 21.337 25.0717 21.3359 25.079 21.3333C25.0863 21.3307 25.093 21.3267 25.0987 21.3214C25.1044 21.3161 25.1089 21.3097 25.112 21.3026C25.1152 21.2955 25.1168 21.2878 25.1169 21.2801V8.71809C25.1158 8.70274 25.1089 8.68835 25.0977 8.67787C25.0864 8.66739 25.0716 8.66158 25.0562 8.66162"
                    fill="white"
                  />

                  <path
                    d="M4.945 21.3408H6.88761C6.90264 21.3408 6.91706 21.3349 6.92774 21.3243C6.93843 21.3138 6.94451 21.2994 6.94467 21.2844V16.2676C6.95028 15.4555 7.27819 14.6789 7.85627 14.1086C8.43436 13.5383 9.21528 13.2209 10.0273 13.2262C10.2714 13.2213 10.5154 13.2402 10.7558 13.2826H10.7704C10.8056 13.2905 10.8408 13.2978 10.8748 13.3069H10.8815C10.9197 13.3166 10.9574 13.327 10.9944 13.3385C11.1944 13.3964 11.3878 13.4747 11.5717 13.5722L11.5924 13.5819C11.7576 13.6633 11.9152 13.7592 12.0634 13.8685C12.19 13.9616 12.3103 14.063 12.4234 14.172C12.4321 14.18 12.4426 14.1857 12.4541 14.1885C12.4656 14.1912 12.4776 14.191 12.489 14.1878C12.5003 14.1845 12.5106 14.1784 12.5189 14.17C12.5272 14.1616 12.5332 14.1512 12.5363 14.1398L13.0408 12.2075C13.0472 12.183 13.0462 12.1572 13.038 12.1332C13.0298 12.1093 13.0147 12.0883 12.9947 12.0728C12.887 11.9858 12.7706 11.9101 12.6474 11.8469C11.8669 11.4158 10.9894 11.1908 10.0978 11.1931C10.0735 11.1931 10.0498 11.1931 10.0261 11.1931C8.91613 11.1916 7.83516 11.5477 6.94345 12.2088V11.2514C6.94337 11.244 6.94183 11.2367 6.93892 11.2299C6.93601 11.223 6.93179 11.2168 6.92649 11.2117C6.92119 11.2065 6.91492 11.2024 6.90804 11.1996C6.90116 11.1969 6.89381 11.1955 6.88639 11.1956H4.94379C4.93637 11.1955 4.92901 11.1969 4.92213 11.1996C4.91525 11.2024 4.90899 11.2065 4.90369 11.2117C4.89839 11.2168 4.89416 11.223 4.89125 11.2299C4.88834 11.2367 4.8868 11.244 4.88672 11.2514V21.2813C4.88688 21.2964 4.89297 21.3107 4.90365 21.3213C4.91434 21.3319 4.92876 21.3378 4.94379 21.3378"
                    fill="white"
                  />

                  <path
                    d="M14.1241 21.3408H16.0667C16.0821 21.3409 16.0969 21.335 16.1082 21.3246C16.1194 21.3141 16.1263 21.2997 16.1274 21.2844V16.2676C16.1301 15.8655 16.212 15.4678 16.3684 15.0973C16.5247 14.7269 16.7526 14.3908 17.0388 14.1084C17.3251 13.826 17.6642 13.6027 18.0367 13.4514C18.4092 13.3 18.808 13.2235 19.2101 13.2262C19.4542 13.2213 19.6981 13.2402 19.9385 13.2826H19.9531C19.9883 13.2905 20.0229 13.2978 20.0575 13.3069H20.0642C20.1025 13.3166 20.1395 13.327 20.1771 13.3385C20.3769 13.3963 20.5702 13.4746 20.7538 13.5722L20.7751 13.5819C20.9401 13.6632 21.0976 13.7591 21.2456 13.8685C21.3724 13.9613 21.4926 14.0627 21.6055 14.172C21.6141 14.1802 21.6247 14.186 21.6362 14.1889C21.6477 14.1918 21.6598 14.1916 21.6712 14.1883C21.6827 14.1851 21.693 14.1789 21.7013 14.1704C21.7096 14.1618 21.7155 14.1513 21.7185 14.1398L22.2229 12.2075C22.2293 12.183 22.2283 12.1572 22.2201 12.1332C22.2119 12.1093 22.1968 12.0882 22.1768 12.0728C22.0694 11.9856 21.9532 11.91 21.8302 11.8469C21.0496 11.4159 20.1721 11.1909 19.2805 11.1931C19.2568 11.1931 19.2331 11.1931 19.2095 11.1931C18.0994 11.1915 17.0184 11.5476 16.1268 12.2088V11.2514C16.1266 11.2437 16.1249 11.2361 16.1218 11.2291C16.1186 11.222 16.114 11.2157 16.1084 11.2105C16.1027 11.2053 16.096 11.2013 16.0888 11.1987C16.0815 11.1961 16.0738 11.1951 16.0661 11.1956H14.1235C14.1161 11.1955 14.1087 11.1969 14.1018 11.1996C14.0949 11.2024 14.0887 11.2065 14.0834 11.2117C14.0781 11.2168 14.0738 11.223 14.0709 11.2299C14.068 11.2367 14.0665 11.244 14.0664 11.2514V21.2813C14.0666 21.2963 14.0726 21.3107 14.0833 21.3213C14.094 21.3319 14.1084 21.3378 14.1235 21.3378"
                    fill="white"
                  />
                </svg>
              </span>

              <span className="login-page-right-button-text">
                <h5>RR Donnelley SSO</h5>

                <p>Unlock The MyConnect Experience</p>
              </span>
            </button>
            <button
              type="button"
              className="login-page-right-button williamsbutton"
              onClick={()=> auth.signinRedirect({

          extraQueryParams: {
          identity_provider: "WL-SSO", // Your custom IDP here
          }

            })}
            >
              <span className="login-page-right-button-icon">
                <img src={WilliamsLeeLogo} alt="Williams Leo logo" />
              </span>

              <span className="login-page-right-button-text">
                <h5>Williams Lea SSO</h5>

                <p>Unlock The MyConnect Experience</p>
              </span>
            </button>
          </div>
          <div className="login-page-right-hublink-container">
            <button type="button">
              <img
              src={`${configJson.AutomicURL}/ITProjects/HCM/img/svg/loginpagedownloadhubapp.svg`}
              alt="Download hub icon"
              />
            </button>
          </div>
          <div className="login-page-right-hublink-text">
            <p>
              <span className="font-bold">
                Unlock the power of our Mobile App. Scan the QR to start.
              </span>
            </p>
          </div>
          <div class="login-page-right-barcode-container">
                    <div class="androidcontainer"> <span class="android-barcode">

          <img src={QRCode} alt="Android Users Barcode" />

        </span>
 <span class="android-text-container">

          <span>

            <h5>For</h5>

            <h6>Android Users</h6>

          </span>
</span>
                    </div>
                    <div class="ioscontainer"> <span class="ios-barcode">

          <img src={IOSQRCode} alt="IOS Users Barcode" />

        </span>
 <span class="ios-text-container">

          <span>

            <h5>For</h5>

            <h6>IOS Users</h6>

          </span>
</span>
                    </div>
                </div>
          <div className="login-page-right-footer-container">
            <div className="login-page-contacts-container">
              <div className="login-page-contacts-details">
                <h1>
                  {helptext &&
                    helptext.map((data) => (
                      <p>
                        <span className="px-1.5"> </span>
                        {data.config_Name}
                      </p>
                    ))}
                </h1>
                <p>
                  <span className="px-1.5">
                    <img
                      className="w-5"
                      src={`${configJson.AutomicURL}/ITProjects/HCM/img/svg/loginpagehelplineicon.svg `}
                      alt="Helpline icon"
                    />
                  </span>
                  North America No:
                  {support &&
                    support.map((data) => <span>{data.config_Name}</span>)}
                </p>
                 <p>
                  <span className="px-1.5">
                    <img
                      className="w-5"
                      src={`${configJson.AutomicURL}/ITProjects/HCM/img/svg/loginpagehelplineicon.svg `}
                      alt="Helpline icon"
                    />
                  </span>
                  International No:
                  {Internaltionsupport &&
                    Internaltionsupport.map((data) => <span>{data.config_Name}</span>)}
                </p>
                <p>
                  
                  <span className="px-1.5">
                    <img
                      className="w-5"
                      src={`${configJson.AutomicURL}/ITProjects/HCM/img/svg/loginpagesupportemailicon.svg`}
                      alt="Support email icon"
                    />
                  </span>
                Email:
                  {email &&
                    email.map((data) => (
                      <span key={data.config_ID}>
                        <a
                          target="_blank"
                          rel="noopener noreferrer"
                          href={`https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
                            data.config_Name
                          )}`}
                        >
                          {data.config_Name}
                        </a>
                      </span>
                    ))}
                </p>
                <p>
                  
                  <span className="for-queires-icon">
                    <img
                      className="w-5"
                      src={`${configJson.AutomicURL}/ITProjects/HCM/img/gif/loginpageforqueriesgif.gif`}
                      alt="For Queries"
                    />
                  </span>
                  For Technical Support:
                  {query &&
                    query.map((data) => (
                      <span className="underline">
                        <a target="_blank" href={data.menu_URL}>
                          {data.config_Name}
                        </a>
                      </span>
                    ))}
                </p>
              </div>
              <div className="login-page-contacts-icon">                
                {chatbot &&
                  chatbot.map((data) => (
                    <a target="_blank" href={data.menu_URL}>
                      <img
                        className="w-14"
                        src={`${configJson.AutomicURL}/ITProjects/HCM/img/gif/loginpageenquirygif.gif`}
                        alt="Contact Icon"
                      />
                    </a>
                  ))}
              </div>
            </div>
            <div className="login-page-copyright-container">
              {copyright && copyright.map((data) => <p>{data.config_Name}</p>)}
            </div>
          </div>
        </div>
      </div>
    );
  }
  else
  {
   <Preloader />
  }
};
export default LoginPage;
